import EditAcsPkomModal from './containers/EditAcsPkomModal'

export default EditAcsPkomModal
